function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.1001 16.0996H10.5001",
  stroke: "#02BC4D",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5001 25.1998H3.1001C2.54781 25.1998 2.1001 24.7521 2.1001 24.1998V14.9811C2.1001 14.8612 2.12166 14.7423 2.16377 14.63L4.13643 9.36959C4.17853 9.25732 4.2001 9.13838 4.2001 9.01847V3.7998C4.2001 3.24752 4.64781 2.7998 5.2001 2.7998H7.4001C7.95238 2.7998 8.4001 3.24752 8.4001 3.79981V9.01847C8.4001 9.13838 8.42166 9.25732 8.46377 9.36959L10.4364 14.63C10.4785 14.7423 10.5001 14.8612 10.5001 14.9811V24.1998C10.5001 24.7521 10.0524 25.1998 9.5001 25.1998Z",
  stroke: "#151515",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 15.4001,
  y1: 10.1997,
  x2: 26.6001,
  y2: 10.1997,
  stroke: "#02BC4D",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.0002 25.1997L21.0002 17.4997",
  stroke: "#151515",
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M21.0001 17.4998C24.0929 17.4998 26.6001 14.9926 26.6001 11.8998C26.6001 10.4331 26.6001 8.90847 25.288 6.75117C25.1142 6.46551 24.7993 6.2998 24.465 6.2998H17.5353C17.201 6.2998 16.8861 6.46551 16.7123 6.75117C15.4001 8.90847 15.4001 10.4331 15.4001 11.8998C15.4001 14.9926 17.9074 17.4998 21.0001 17.4998Z",
  stroke: "#151515",
  strokeWidth: 2
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5002 25.1997H24.5002",
  stroke: "#02BC4D",
  strokeWidth: 2
});

var SvgMoreDrinks = function SvgMoreDrinks(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoreDrinks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/more-drinks.80b9e8e6.svg";
export { ForwardRef as ReactComponent };